import type {
  CommunityUser,
  CurrentUserProfile,
  CurrentUserProfileV2,
  MyCourse,
  MyGroupMembership,
} from '../types/currentUser'

import { defineStore } from 'pinia'

interface CurrentUserState {
  profile: CurrentUserProfile | CurrentUserProfileV2 | null
  myGroups: MyGroupMembership[]
  myCourses: MyCourse[]
  communityUser: CommunityUser | null
  gokollabUser: { [key: string]: unknown } | null
  isLoadingProfile: boolean
  isLoadingGroups: boolean
  isLoadingCourses: boolean
  isLoadingCommunityUser: boolean
  error: string | null
}

export const useCurrentUserStore = defineStore('current-user', {
  state: (): CurrentUserState => ({
    profile: null,
    myGroups: [],
    myCourses: [],
    communityUser: null,
    gokollabUser: null,
    isLoadingProfile: false,
    isLoadingGroups: false,
    isLoadingCourses: false,
    isLoadingCommunityUser: false,
    error: null,
  }),

  getters: {
    hasProfile: (s) => !!s.profile,
    groupById: (s) => (groupId: string) =>
      s.myGroups.find((g: MyGroupMembership) => g.groupId === groupId) || null,
    courseById: (s) => (courseId: string) =>
      s.myCourses.find((c: MyCourse) => c.courseId === courseId) || null,
    getUserFullName: (s) => s.profile?.fullName || s.profile?.email || '',
    getGokollabUser: (s) => s.gokollabUser,
  },

  actions: {
    setProfile(profile: CurrentUserProfile | CurrentUserProfileV2) {
      this.profile = profile
    },
    setMyGroups(groups: MyGroupMembership[]) {
      this.myGroups = groups
    },
    setMyCourses(courses: MyCourse[]) {
      this.myCourses = courses
    },
    setCommunityUser(communityUser: CommunityUser | null) {
      this.communityUser = communityUser
    },
    setGokollabUser(gokollabUser: { [key: string]: unknown }) {
      this.gokollabUser = gokollabUser
    },
    setLoadingProfile(v: boolean) {
      this.isLoadingProfile = v
    },
    setLoadingGroups(v: boolean) {
      this.isLoadingGroups = v
    },
    setLoadingCourses(v: boolean) {
      this.isLoadingCourses = v
    },
    setLoadingCommunityUser(v: boolean) {
      this.isLoadingCommunityUser = v
    },
    setError(message: string | null) {
      this.error = message
    },

    reset() {
      this.profile = null
      this.myGroups = []
      this.myCourses = []
      this.communityUser = null
      this.gokollabUser = null
      this.error = null
      this.isLoadingProfile =
        this.isLoadingGroups =
        this.isLoadingCourses =
        this.isLoadingCommunityUser =
          false
    },
  },
})
